import { useState, useReducer, useEffect, useRef, Fragment } from 'react';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';
import listingsReducer from '@Components/Listings/ListingsReducer';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
const PrintWebListing = loadable(() => import('@Components/Listings/PrintWebListing'));
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { sandhillsRequest, gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import TranslationText from '@Components/Utilities/TranslationText';

const PrintEventSaleCatalog = (props) => {

    const routes = useRecoilValue(atoms.routes);
    const [listings, dispatchListings] = useReducer(listingsReducer, props.ListPageAjaxModel.Listings);
    const currentUser = useRecoilValue(atoms.currentUser);
    const currentWebsite = useRecoilValue(atoms.currentWebsite);
    const [shouldPrint, setShouldPrint] = useState(false);
    const [loadImagesForPrint, setLoadImagesForPrint] = useState(false);

    useEffect(() => {

        getListingAuctionData(listings, dispatchListings);

        const timer = setTimeout(() => {
            setShouldPrint(true);
        }, 2500);

        return () => clearTimeout(timer);

    }, []);

    useEffect(() => {
        if (shouldPrint) {
            window.print();
        }
    }, [shouldPrint]);


    const getListingAuctionData = (listings, dispatchListings) => {
        if (listings?.length > 0) {
            const atListings = getListingAuctionData_ATModels(listings);
            const efListings = getListingAuctionData_EFModels(listings);

            if (atListings?.length > 0 || efListings?.length > 0) {
                sandhillsRequest({
                    url: routes.GetAuctionData,
                    method: 'post',
                    data: {
                        search: {
                            AuctionTimeModels: atListings,
                            EquipmentFactsModels: efListings
                        }
                    },
                    errorHandling: {
                        message: 'Error retrieving auction data',
                        showDetails: true,
                        useConsole: true,
                        useAlert: false
                    }
                }).then((response) => {
                    const data = response;

                    if (data) {
                        if (data.AuctionTimeResult?.length > 0) {
                            data.AuctionTimeResult.forEach(auctionResult => {
                                const listingIndex = listings.findIndex(item => item.Id === auctionResult.ListingID);
                                if (listingIndex > -1) {
                                    dispatchListings({
                                        type: 'update-listing',
                                        payload: {
                                            Id: listings[listingIndex].Id,
                                            AuctionBiddingData: auctionResult
                                        }
                                    });
                                }
                            });
                        }

                        if (data.EquipmentFactsResult?.length > 0) {
                            data.EquipmentFactsResult.forEach(auctionResult => {
                                const listingIndex = listings.findIndex(item => item.Id === auctionResult.ListingID);
                                if (listingIndex > -1) {
                                    dispatchListings({
                                        type: 'update-listing',
                                        payload: {
                                            Id: listings[listingIndex].Id,
                                            AuctionBiddingData: auctionResult
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    const getListingAuctionData_ATModels = (listings) => {
        const atListings = listings.filter(listing => listing && listing.IsAT === true && !listing.IsAuctionResult);

        return (atListings?.length > 0) ?
            atListings.map(m => ({
                LegacyBaseCatID: m.LegacyBaseCategoryId,
                BaseCatID: m.BaseCategoryId,
                ListingID: m.Id,
                AverageWeight: m.AverageWeight,
                Quantity: m.Quantity,
                NextBidAmount: m.NextBidAmount,
                IsAuctionLive: m.IsAuctionLive
            })) : [];
    };
    const getListingAuctionData_EFModels = (listings) => {
        const efListings = listings.filter(listing => listing && listing.IsEF === true && !listing.IsAuctionResult);

        return (efListings?.length > 0) ?
            efListings.map(m => ({
                LegacyBaseCatID: m.LegacyBaseCategoryId,
                BaseCatID: m.BaseCategoryId,
                ListingID: m.Id,
                CurrencyCode: m.CurrencyCode,
                EventID: m.EventID,
                ListingTitle: m.ListingTitle,
                ListingSerialNumber: m.SerialNumber,
                AuctionPriceLabel: m.AuctionPriceLabel,
                Quantity: m.Quantity,
                NextBidAmount: m.NextBidAmount
            })) : [];
    };

    useEffect(function printEffect() {
        if (loadImagesForPrint) {
            if (listings.every(listing => listing.ImagesLoaded)) {
                window.print();
                setLoadImagesForPrint(false);
            }
        }
    }, [listings]);

    const onPrint = () => {
        gtmPushEvent(gtmEventType.printListDetail);
        setLoadImagesForPrint(true);
        dispatchListings({
            type: 'update-listings',
            payload: [...listings].map(listing => {
                return {
                    ...listing,
                    ForceLoadImages: true
                };
            })
        });
    };

    return (
        <>
            <div className='list-content' id='toplevellist'>
                <section className='print-list-top-section'>
                    <div className="print-event-header">
                        {props.IsPrintListPage && !props.HostedLogoUrl && !props?.InventoryHeader?.LogoUrl && <LazyLoadImage src={props.LogoUrl} className='dealer-header-title-logo' alt="" />}
                        {props.HostedLogoUrl && <LazyLoadImage src={props.HostedLogoUrl} className='dealer-header-title-logo' alt="" />}
                        {props?.InventoryHeader?.LogoUrl && !props.HostedLogoUrl ?
                            <div>
                                <LazyLoadImage src={props.InventoryHeader.LogoUrl} className="dealer-header-title-logo" alt={props.Name} />
                                {props?.InventoryHeader?.EventTitle ?
                                    <>
                                        <h1 className="event-title-with-logo">{props.InventoryHeader.EventTitle}</h1>
                                    </>
                                    :
                                    <h1>{props.PageHeader}</h1>
                                }
                            </div> :
                            <div>
                                {props?.InventoryHeader?.Name ?
                                    <>
                                        <h1 aria-label={props.InventoryHeader.Name}>{props.InventoryHeader.Name}</h1>
                                        <h2>{props.InventoryHeader.EventTitle}</h2>
                                    </> :
                                    <h1>{props.PageHeader}</h1>
                                }
                            </div>}
                        <button id='list-page-print-this' type='button' className='print-this des-print-this ts-button' onClick={onPrint} disabled={loadImagesForPrint}>
                            <i className='fas fa-print media-buttons__icon' /> <TranslationText tKey='sandhills.print' />
                        </button>
                    </div>

                </section>
                
                <main className='print-main-content'>
                    <section className='bottom-section'>
                        <h2 className='visually-hidden'>{translator.translate('sandhills.tradepubwebsite.mvc.listings')}</h2>
                        {listings && listings.length > 0 && props.UserCanViewListings &&
                            <div className='print-list-container' id='printListContainer'>
                                {listings.map((listing) =>
                                    <Fragment key={listing.Id}>
                                        <div className='print-list-listing-wrapper'>
                                            <PrintWebListing
                                                {...listing}
                                                LazyLoad={false}
                                                ListPageDescriptionMaxLength={props.ListPageDescriptionMaxLength}
                                                ListPageSpecMaxLength={props.ListPageSpecMaxLength}
                                                LocationString={props.ListPageAjaxModel.LocationString}
                                                DispatchListings={dispatchListings}
                                                ForceLoadImages={true}
                                                DetailUrl={listing.DetailUrl}
                                                IsPrintEventSaleCatalog={props.IsPrintEventSaleCatalog}
                                                IsPrintListPage={props.IsPrintListPage}
                                                CurrentSite={currentWebsite}
                                                ShowAuctionResults={!props.FacetedSearchAjaxModel.UnauthorizedAuctionResultRequest && !currentWebsite.RequiresFullRegistration || (currentWebsite.RequiresFullRegistration && !currentUser.IsMinReg)}
                                            />
                                        </div>
                                    </Fragment>)}
                            </div>
                        }
                    </section>
                    </main>
                    <div className='clear' />
            </div>
        </>
    );
};

export default PrintEventSaleCatalog;
global.PrintEventSaleCatalog = PrintEventSaleCatalog;